export function getLabel(value: any, defaultValue: any) {
    if (value === undefined || value === null) {
        return defaultValue;
    }
    return value;
}



// WEBPACK FOOTER //
// ./src/utils/getLabel.ts